import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/app/public/ai/data_report.png");
;
import(/* webpackMode: "eager" */ "/app/public/ai/data_report/d1.png");
;
import(/* webpackMode: "eager" */ "/app/public/ai/data_report/d2.png");
;
import(/* webpackMode: "eager" */ "/app/public/ai/data_report/d3.png");
;
import(/* webpackMode: "eager" */ "/app/public/ai/data_report/d4.png");
;
import(/* webpackMode: "eager" */ "/app/public/ai/data_report/d5.png");
;
import(/* webpackMode: "eager" */ "/app/public/homePage/icons/bullet.svg");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/Component/Aicrousel/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/Component/ProductCarousel/NewSlider.tsx");
